<template>
	<div>
		<div class="home_con_1">
			<img class="home_con_1_img" :src="bannerImage" />
		</div>
		<div class="container">
			<div class="header">
				<!-- <div>
					<label>{{ $t('footer.serviceHotline') }}</label>
					<label class="header_content_text">{{ footerData.serviceHotline }}</label>
				</div> -->
				<div style="width: 100%;">
					<label>{{ $t('footer.email') }}</label>
					<label class="header_content_text">{{ footerData.email }}</label>
				</div>
				<div style="width: 100%;">
					<label>{{ $t('footer.address') }}</label>
					<label class="header_content_text">{{ footerData.address }}</label>
				</div>
			</div>
			<img src="../assets/contactus.jpg" style="width: 100%; height: auto" />
			<div class="form-contene">
				<h1>{{ $t('messageForm.welcome') }}</h1>
				<form @submit.prevent="submitForm">
					<div class="form-group">
						<div class="form-item">
							<label>
								{{ $t('messageForm.name') }}
								<span class="required">*</span>
							</label>
							<input type="text" v-model="form.name" required />
						</div>

						<div class="form-item">
							<label>
								{{ $t('messageForm.phone') }}
								<span class="required">*</span>
							</label>
							<input type="text" v-model="form.phone" required />
						</div>
					</div>

					<div class="form-group">
						<div class="form-item">
							<label>{{ $t('messageForm.company') }}</label>
							<input type="text" v-model="form.company" />
						</div>

						<div class="form-item">
							<label>{{ $t('messageForm.businessType') }}</label>
							<input type="text" v-model="form.businessType" />
						</div>
					</div>

					<div class="form-group">
						<div class="form-item">
							<label>
								{{ $t('messageForm.city') }}
								<span class="required">*</span>
							</label>
							<input type="text" v-model="form.city" required />
						</div>

						<div class="form-item">
							<label>{{ $t('messageForm.industry') }}</label>
							<input type="text" v-model="form.industry" />
						</div>
					</div>

					<div class="form-group">
						<div class="form-item full-width">
							<label>
								{{ $t('messageForm.description') }}
								<span class="required">*</span>
							</label>
							<textarea v-model="form.description" required></textarea>
						</div>
					</div>

					<div class="submit-btn">
						<button type="submit">{{ $t('messageForm.submit') }}</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { contactApi, footerInfoApi, bannerApi, baseImgUrl } from '../netTool/api';

export default {
	data() {
		return {
			form: {
				name: '',
				phone: '',
				company: '',
				businessType: '',
				city: '',
				industry: '',
				description: ''
			},
			footerData: {
				email: '',
				serviceHotline: '',
				address: ''
			},
			bannerImage: ''
		};
	},
	mounted() {
		this.getbannerImg();
		this.getFooterInfo();
	},
	methods: {
		async getbannerImg() {
			const navId = 7;
			const response = await bannerApi.getBanner(navId);
			if (response.success) {
				this.bannerImage = baseImgUrl + response.banner.image_url;
			}
		},
		async getFooterInfo() {
			try {
				const response = await footerInfoApi.getFooterData();
				if (response.success) {
					this.footerData = {
						email: response.data.email,
						serviceHotline: response.data.serviceHotline,
						address: response.data.address
					};
				}
			} catch (error) {
				console.error('获取页脚信息失败:', error);
			}
		},
		async submitForm() {
			const submitData = {
				name: this.form.name.trim(),
				phone: this.form.phone.trim(),
				company: this.form.company.trim() || null,
				business_type: this.form.businessType.trim() || null,
				city: this.form.city.trim(),
				industry: this.form.industry.trim() || null,
				description: this.form.description.trim(),
				is_replied: 0 // 默认未回复
			};

			try {
				const response = await contactApi.createMessage(submitData);

				if (response.success) {
					alert(this.$t('messageForm.successAlert'));
					this.form = {
						name: '',
						phone: '',
						company: '',
						businessType: '',
						city: '',
						industry: '',
						description: ''
					};
				} else {
					alert(this.$t('messageForm.failAlert', { message: response.message || 'Unknown error' }));
				}
			} catch (error) {
				alert(this.$t('messageForm.errorAlert'));
			}
		}
	}
};
</script>

<style scoped>
.container {
	max-width: 1000px;
	margin: 0 auto;
	padding: 20px;
}

.header {
	font-size: 32px;
	/* display: grid; */
	grid-template-columns: repeat(2, 1fr);
	gap: 30px;
	color: #333;
	margin: 35px 0 55px 0;
}

.header_content_text {
	font-size: 22px;
	font-weight: 400;
	color: #999;
	border-bottom: 1px solid #d9d9d9;
	padding: 10px 3px 20px 3px;
}

h1 {
	text-align: center;
	color: #333;
	margin: 45px;
}

.form-group {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	flex-wrap: wrap;
}

.form-item {
	width: 48%;
	margin-bottom: 15px;
}

.full-width {
	width: 100%;
}

label {
	display: block;
	margin-bottom: 14px;
	font-weight: bold;
}

.required {
	color: red;
}

input,
textarea {
	width: 100%;
	padding: 10px;
	border: 1px solid #ddd;
	border-radius: 5px;
}

textarea {
	height: 200px;
	resize: none;
}

.submit-btn {
	display: flex;
	justify-content: center;
	margin-top: 20px;
}

.submit-btn button {
	padding: 13px 70px;
	background-color: #888;
	color: white;
	border: none;
	border-radius: 24px;
	cursor: pointer;
}

.submit-btn button:hover {
	background-color: #666;
}
</style>
